import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import ActivityStream from '../activities/activity-stream.js'
import { graphHooks } from '@tunasong/graph-lib/react'

export const SidebarActivities: FC<SidebarComponent> = ({ entity }) => {
  const activities = graphHooks.useActivities(entity.id)

  return (
    <div style={{ overflow: 'auto' }}>
      <ActivityStream activities={activities} />
    </div>
  )
}
